import type { TimelineItem } from "@/types/topic";

type ArticleTimelineProps = {
  items: TimelineItem[];
};

export default function ArticleTimeline({ items }: ArticleTimelineProps) {
  return (
    <ol className="relative ml-2 border-l-2 border-background-200 pl-6 md:ml-3 md:pl-8">
      {items.map((item, index) => (
        <li key={`${item.date}-${index}`} className="relative pb-8 last:pb-0">
          <span
            className={`absolute -left-[31px] top-1.5 flex h-5 w-5 items-center justify-center rounded-full border-2 md:-left-[39px] ${
              index === items.length - 1
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-300 bg-background-50 text-foreground-400"
            }`}
          >
            <i className="text-[10px] ri-checkbox-blank-circle-line" aria-hidden="true"></i>
          </span>

          <div className="flex flex-wrap items-center gap-2">
            <time className="rounded-md bg-foreground-900 px-2.5 py-1 font-heading text-xs font-semibold text-background-50">
              {item.date}
            </time>
            <span className="rounded-full border border-secondary-200 bg-secondary-50 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
              {item.side}
            </span>
          </div>

          <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
            {item.title}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            {item.detail}
          </p>
        </li>
      ))}
    </ol>
  );
}